const PLACEHOLDER = "unknown";

/** A displayable given name. Drops blanks and the User create placeholder. */
export function usableGivenName(value: string | null | undefined): string {
  const trimmed = value?.trim() ?? "";
  if (!trimmed || trimmed.toLowerCase() === PLACEHOLDER) return "";
  return trimmed;
}

/**
 * Home greeting name. Clerk profile wins. CIP legal first name is the
 * fallback for email sign-up, which does not collect a name. Empty means
 * the greeting renders with no name.
 */
export function homeGreetingName(sources: {
  clerkFirstName?: string | null;
  clerkFullName?: string | null;
  cipFirstName?: string | null;
}): string {
  const fromClerk =
    usableGivenName(sources.clerkFirstName) ||
    usableGivenName(
      sources.clerkFullName?.trim().split(/\s+/).filter(Boolean)[0],
    );
  if (fromClerk) return fromClerk;
  return usableGivenName(sources.cipFirstName);
}
